export default __webpack_public_path__ + "static/media/School Program - Class 9.6dad4161.jpg";